export default __webpack_public_path__ + "static/media/Udyog-Aadhaar-Registration.a3744368.png";